import { TCategory, TTopCategory } from '../data';

export const getSortOrder = (searchId: number, topCategories: TTopCategory[]) =>
	topCategories.filter(({ topCategoryId }) => topCategoryId === searchId)[0].sortOrder;

type TSortData = TTopCategory[] | TCategory[];

type TSortList = (data: TSortData) => TSortData;

export const sortList: TSortList = data =>
	data.sort((a: TTopCategory | TCategory, b: TTopCategory | TCategory) =>
		compareElements(a.sortOrder, b.sortOrder)
	);

export const sortListWithIds = (listWithIds: number[], topCategories: TTopCategory[]): number[] =>
	[...listWithIds].sort((a: number, b: number) => {
		const aSortOrder = getSortOrder(a, topCategories);
		const bSortOrder = getSortOrder(b, topCategories);
		return compareElements(aSortOrder, bSortOrder);
	});

export const compareElements = (a: number | null, b: number | null): number => {
	if (a === b) return 0;
	if (a == null) return 1;
	if (b == null) return -1;
	return a - b;
};
